module.exports = __webpack_public_path__ + "img/operation_drag1.6d82dc3d.svg";